import { Children } from 'react';
import type { FunctionComponent } from 'react';

import styles from './layouts.module.less';

type FluidLeftLayoutComponent = FunctionComponent & {
  Left: FunctionComponent;
  Right: FunctionComponent;
};

/**
 * FluidLeftLayout is a two-column page layout.
 * Used to when there is main content, such as a list of data,
 * as well as a sidebar with actions/filters for that data.
 * Note that FluidLeftLayout only accepts two child elements
 * and will not render any additional children.
 *
 * @example
 * <FluidLeftLayout>
 *   <FluidLeftLayout.Left>
 *     <Inbox />
 *   </FluidLeftLayout.Left>
 *   <FluidLeftLayout.Right>
 *     <Filters />
 *   </FluidLeftLayout.Right>
 * </FluidLeftLayout>
 */
const FluidLeftLayout: FluidLeftLayoutComponent = ({ children }) => (
  <main className={styles.fluidLeft}>
    {Children.map(children, (child, index) => {
      //  Ensure that only two children are rendered.
      if (index < 2) {
        return child;
      }
      //  Any additonal children passed to FluidLeftLayout are ignored.
      return null;
    })}
  </main>
);

FluidLeftLayout.Left = ({ children }) => (
  // <div className={styles.FluidLeftLayoutMain}>
  <div className={styles.content}>
    {children}
  </div>
);
FluidLeftLayout.Left.displayName = 'FluidLeftLayout.Left';

FluidLeftLayout.Right = ({ children }) => (
  // <aside className={styles.FluidLeftLayoutSidebar}>
  <div className={styles.content}>
    {children}
  </div>
);
FluidLeftLayout.Right.displayName = 'FluidLeftLayout.Right';

export default FluidLeftLayout;
